import type { DailyMetric, DateRange } from './HealthDataReader';

/** Local YYYY-MM-DD for a Date. */
export const toLocalDateKey = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/**
 * Returns a `DailyMetric[]` with one entry per local day between
 * `range.start` and `range.end` inclusive, filling missing days with
 * `value: null` (NOT zero — see reader contract).
 */
export const fillMissingDays = (
  range: DateRange,
  populated: Map<string, number>,
): DailyMetric[] => {
  const out: DailyMetric[] = [];
  const cursor = new Date(range.start);
  cursor.setHours(0, 0, 0, 0);
  const stop = new Date(range.end);
  stop.setHours(0, 0, 0, 0);
  while (cursor <= stop) {
    const key = toLocalDateKey(cursor);
    out.push({ date: key, value: populated.has(key) ? populated.get(key)! : null });
    cursor.setDate(cursor.getDate() + 1);
  }
  return out;
};
